import { createSlice } from "@reduxjs/toolkit";

const initialProjectCategoryState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  projectCategoryForEdit: undefined,
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const projectCategorySlice = createSlice({
  name: "projectCategory",
  initialState: initialProjectCategoryState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getProjectCategoryById
    projectCategoryFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.projectCategoryForEdit = action.payload.projectCategoryForEdit;
    },
    // findProject
    projectCategoriesFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items[0]?.count ?? 0;
    },
    // Set to default state actionLoading & error
    projectCategoryReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
  },
});
